<template>
    <div>
        <div class="float-right my-3">
            <date-picker
                v-model="date"
                type="date"
                range
                :format="changeFormat"
                :lang="lang"
                @input="prepareData"
                confirm
                placeholder="วันที่" >
            </date-picker>
            <br>
            <span>*หากไม่ได้เลือกจะเป็นข้อมูลเดือนปัจจุบัน</span>
        </div>
        <table style="text-align: center" class="table table-bordered">
            <thead>
            <tr>
                <th scope="col">วันที่</th>
                <th scope="col">#จ่ายเงิน</th>
                <th scope="col">รหัส-ชื่อ เจ้าหนี้</th>
                <th scope="col">รวม</th>
                <th scope="col">เงินสด</th>
                <th scope="col">เงินโอน</th>
                <th scope="col">เช็ค</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(x,i) in data">
                <tr v-for="(y,index) in x">
                    <td><span v-if="index == 0">{{ y.receive_date }}</span></td>
                    <td>{{ y.no }}</td>
                    <td>{{ y.vendor ? y.vendor.vendor_id : '-' }}-{{ y.vendor ? y.vendor.name : '-' }}</td>
                    <td>{{ y.transactions[0].amount | currency}}</td>
                    <td>{{ y.transactions[0].transaction_type_id == 3 ? y.transactions[0].amount : ''}}</td>
                    <td>{{ y.transactions[0].transaction_type_id == 2 ? y.transactions[0].amount : ''}}</td>
                    <td>{{ y.transactions[0].transaction_type_id == 1 ? y.transactions[0].amount : ''}}</td>
                </tr>
            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker'
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    import moment from "moment"
    import VuePagination from "../../../components/Pagination";
    import {domain} from "../../../util/Constants";

    export default {
        name: "MileSellerCarList",
        created(){
            this.prepareData();
        },
        components:{
            DatePicker,
            Multiselect,
            moment,
            VuePagination,
        },
        computed:{
        ...mapState({
                optionSeller:state=>{
                    return state.Seller.data
                },
                user : state=>{
                    return state.Auth.user;
                },
            }),
        },
        data(){
            return{
                data : [],
                date : [],
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        methods:{
            prepareData(){
                let data = {
                    date_start : this.date.length > 0 && this.date[0] != null ? moment(this.date[0]).format('YYYY-MM-DD'):'',
                    date_end : this.date.length > 0 && this.date[1] != null ? moment(this.date[1]).format('YYYY-MM-DD'):'',
                }
                this.$store.dispatch('Account/getDriverReport',data).then(res=>{
                    this.data = res
                })
            }
        },
    }

</script>

<style scoped>

</style>
